import { useMemo } from 'react'
import type { TFunction } from 'next-i18next/pages'
import type {
    CmsBlock,
    ComplexTextValue,
    ConfigurableProduct,
    Maybe
} from '@pylot/pylotschema'
import {
    buildPdpAccordionContents,
    getCustomAttributeEntries
} from '@components/Product/pdp/blocks/PDPAccordions'

type UsePdpAccordionContentsParams = {
    t: TFunction
    product?: ConfigurableProduct | null
    shortDescription?: Maybe<ComplexTextValue>
    firstAccordionBlockContent?: Maybe<Maybe<CmsBlock | null>[]>
    secondAccordionBlockContent?: Maybe<Maybe<CmsBlock | null>[]>
    isGrouped: boolean
}

export function usePdpAccordionContents({
    t,
    product,
    shortDescription,
    firstAccordionBlockContent,
    secondAccordionBlockContent,
    isGrouped
}: UsePdpAccordionContentsParams) {
    const customAttributes = useMemo(
        () => (product ? getCustomAttributeEntries(product) : []),
        [product]
    )

    const accordionContents = useMemo(
        () =>
            buildPdpAccordionContents({
                t,
                short_description: shortDescription,
                firstAccordionBlockContent,
                secondAccordionBlockContent,
                customAttributes
            }),
        [
            t,
            shortDescription?.html,
            firstAccordionBlockContent,
            secondAccordionBlockContent,
            customAttributes
        ]
    )

    return useMemo(
        () =>
            isGrouped
                ? (accordionContents ?? []).filter(
                      (item: { id?: string }) => item.id !== 'short-description'
                  )
                : (accordionContents ?? []),
        [accordionContents, isGrouped]
    )
}
